import Input from "components/common/input";
import { useEffect, useState, useRef } from "react";
import {
  outreachLeaderInitialValues,
  outreahLeaderAddSchema,
  outreahLeaderEditSchema,
} from "constants/outreachLeader";
import ToggleButton from "components/common/togglebutton";
import { LOGIN_ROLES } from "constants/common";
import { formatLocation, getUserInfo } from "utils/common";
import { ErrorMessage, Formik } from "formik";
import { initialMetaForTable, DEBOUNCE_DELAY } from "constants/common";
import AsyncSelect from "components/common/select/AsyncSelect";
import debounce from "lodash/debounce";
import { getCounties } from "containers/policies/api";
import { useDebouncedCountiesDataCallback } from "utils/debouncedHelper";

const useDebouncedFetchCounties = () => {
  const debouncedFetch = useRef(
    debounce(async (inputValue, callback) => {
      try {
        const response = await getCounties({
          search: inputValue,
        });
        let formattedOptions = response?.counties?.map((el) => ({
          value: el.id,
          label: formatLocation(el.name),
        }));

        if (!formattedOptions || formattedOptions.length === 0) {
          callback([]);
        } else {
          callback(formattedOptions);
        }
      } catch (error) {
        console.error("Failed to fetch members:", error);
        callback([]);
      }
    }, DEBOUNCE_DELAY)
  ).current;

  return debouncedFetch;
};

const OutreachForm = ({
  handleQuestionSubmittion,
  handleClose,
  currentOutreachLeeaderEdit,
}) => {
  const [countiesList, setCountiesList] = useState([]);
  const debouncedFetchCountiesData = useDebouncedFetchCounties();
  console.log("asasasasasasasasasasas", currentOutreachLeeaderEdit);
  useEffect(() => {
    (async () => {
      const result = await getCounties({
        ...initialMetaForTable,
        page: 1,
      });
      if (result?.counties) setCountiesList(result.counties);
    })();
  }, [debouncedFetchCountiesData]);

  console.log(currentOutreachLeeaderEdit);
  const isEditMode =
    typeof currentOutreachLeeaderEdit === "object" ? true : false;
  return (
    <Formik
      initialValues={
        isEditMode
          ? {
              ...currentOutreachLeeaderEdit,
              password: "",
              county_ids: currentOutreachLeeaderEdit?.counties?.map((el) => ({
                label: el.name,
                value: el.id,
              })),
            }
          : outreachLeaderInitialValues
      }
      validationSchema={
        isEditMode ? outreahLeaderEditSchema : outreahLeaderAddSchema
      }
      onSubmit={(values, { setSubmitting, setErrors }) => {
        const payload = {
          ...values,
          county_ids: values.county_ids.map((el) => el.value),
        };
        handleQuestionSubmittion(payload, setSubmitting, setErrors);
      }}
    >
      {({
        handleChange,
        values,
        handleSubmit,
        setFieldValue,
        isSubmitting,
      }) => {
        return (
          <div className="question-modal">
            <form className="form-main" onSubmit={handleSubmit}>
              <hr className="custom-modal-line mt-0 " />
              <div className="input-flex row">
                <div className="col-sm-6">
                  <Input
                    handleChange={handleChange}
                    placeholder="e.g. John Doe"
                    type="text"
                    label="Name"
                    isRequired
                    value={values.name}
                    name="name"
                    error={
                      <ErrorMessage
                        className="error-message"
                        component="p"
                        name="name"
                      />
                    }
                  />
                </div>
                <div className="col-sm-6">
                  <Input
                    handleChange={handleChange}
                    placeholder="e.g. johndoe@gmail.com"
                    type="email"
                    label="Email"
                    isRequired
                    value={values.email}
                    name="email"
                    disabled={isEditMode}
                    error={
                      <ErrorMessage
                        className="error-message"
                        component="p"
                        name="email"
                      />
                    }
                  />
                </div>
              </div>
              <div className="input-flex row">
                <div className={!isEditMode ? "col-sm-6" : "col-sm-12"}>
                  <Input
                    handleChange={handleChange}
                    placeholder="e.g. johndoe"
                    type="text"
                    label="Username"
                    isRequired
                    value={values.username}
                    name="username"
                    error={
                      <ErrorMessage
                        className="error-message"
                        component="p"
                        name="username"
                      />
                    }
                  />
                </div>
                {!isEditMode ? (
                  <div className="col-sm-6">
                    <Input
                      handleChange={handleChange}
                      placeholder="Password"
                      type="password"
                      label="Password"
                      isRequired
                      value={values.password}
                      name="password"
                      className="mb-1"
                      error={
                        <ErrorMessage
                          className="error-message"
                          component="p"
                          name="password"
                        />
                      }
                    />
                  </div>
                ) : null}
              </div>

              <Input
                handleChange={handleChange}
                placeholder="e.g. Northern California"
                type="text"
                label="Default Location"
                isRequired
                value={values.location}
                name="location"
                error={
                  <ErrorMessage
                    className="error-message"
                    component="p"
                    name="location"
                  />
                }
              />
              <div className="col-sm-12">
                <AsyncSelect
                  label="County"
                  isMulti={true}
                  options={countiesList.map((el) => ({
                    value: el.id,
                    label: formatLocation(el.name),
                  }))}
                  dataCallback={(inputValue) =>
                    new Promise((resolve) => {
                      debouncedFetchCountiesData(inputValue, (options) => {
                        if (!options || options.length === 0) {
                          resolve([]);
                        } else {
                          resolve(options);
                        }
                      });
                    })
                  }
                  selectedValue={values?.county_ids}
                  placeholder="Select County"
                  handleChange={(selectedOptions) => {
                    setFieldValue("county_ids", selectedOptions);
                    console.log("asasasasas", selectedOptions);
                  }}
                  error={
                    <ErrorMessage
                      className="error-message"
                      component="p"
                      name="county_ids"
                    />
                  }
                />
              </div>
              {getUserInfo()?.type === LOGIN_ROLES.outreachleader &&
                getUserInfo()?.super_admin && (
                  <div className="col-sm-6 mt-2 pt-1">
                    <ToggleButton
                      label="Superadmin"
                      handleChange={(name, value) => {
                        setFieldValue(name, value ? true : false);
                      }}
                      value={values.super_admin ? 1 : 0}
                      name="super_admin"
                    />
                  </div>
                )}

              <div className="col-sm-6 mt-2 pt-1">
                <ToggleButton
                  label="Status"
                  handleChange={(name, value) => {
                    setFieldValue(name, !!value ? "active" : "inactive");
                  }}
                  value={values.status === "active" ? 1 : 0}
                  name="status"
                />
              </div>
              <hr className="custom-modal-line mt-4 " />

              <div className="action gap-2">
                <button
                  className="secondary-btn w-50"
                  type="button"
                  onClick={handleClose}
                >
                  Cancel
                </button>
                {isSubmitting ? (
                  <>
                    <span className="primary-btn w-50">
                      <span
                        className="spinner-grow spinner-grow-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      Submitting...
                    </span>
                  </>
                ) : (
                  <input
                    className="primary-btn w-50"
                    type="submit"
                    name="submit"
                    value={isEditMode ? "Save Changes" : "Add Outreach Leader"}
                  />
                )}
              </div>
            </form>
          </div>
        );
      }}
    </Formik>
  );
};

export default OutreachForm;
